module.exports = __webpack_public_path__ + "static/media/chrome.05788ff9.png";